import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Globals } from '../global/globals';
import { ProjectState } from '../dtos/project-state';
import {
  DataExtractionAgreementOfficial,
  DataExtractionAgreementPreview,
} from '../dtos/data-extraction-agreement';

@Injectable({
  providedIn: 'root',
})
export class DataExtractionAgreementService {
  constructor(
    private httpClient: HttpClient,
    private globals: Globals,
  ) {}

  getPreview(projectId: string): Observable<DataExtractionAgreementPreview> {
    return this.httpClient.get<DataExtractionAgreementPreview>(this.uri(projectId, 'preview'));
  }

  getOfficial(projectId: string): Observable<DataExtractionAgreementOfficial> {
    return this.httpClient.get<DataExtractionAgreementOfficial>(this.uri(projectId, 'official'));
  }

  private uri(projectId: string, kind: 'preview' | 'official'): string {
    return `${this.globals.backendUri}/projects/${projectId}/stages/${ProjectState.DATA_EXTRACTION}/agreement/${kind}`;
  }
}
